export default "__VITE_ASSET__QB5aWgid__"